// extracted by mini-css-extract-plugin
export default {"iconWrapper":"infoPlusIconWithTooltip_iconWrapper__w8Sbu","icon":"infoPlusIconWithTooltip_icon__KzrVu"};